import { render, staticRenderFns } from "./textBook.vue?vue&type=template&id=12a675f1&scoped=true&"
import script from "./textBook.vue?vue&type=script&lang=js&"
export * from "./textBook.vue?vue&type=script&lang=js&"
import style0 from "./textBook.vue?vue&type=style&index=0&id=12a675f1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a675f1",
  null
  
)

export default component.exports